export const ALERT_ERROR = "danger";
export const ALERT_SUCCESS = "success";
export const MASK_CNPJ = "99.999.999/9999-99";
export const OPERATOR = "OPERATOR";
export const PATTERN_PHONE =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
// export const PHONE = /^\(?([0-9]{2})\)?[-. ]?([0-9]{5})[-. ]?([0-9]{4})$/
// export const PHONE_NUMBER_MASK = ["(", /\d/, /\d/, ")", " ", /\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]
export const RESELLER = "RESELLER";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_OPERATOR = "ROLE_OPERATOR";
export const ROLE_OPERATOR_FULL = "ROLE_OPERATOR_FULL";
export const ROLE_RESELLER = "ROLE_RESELLER";
export const ROLE_SUPER_ADMIN = "ROLE_SUPER_ADMIN";
export const SCREEN_BLOCKED = "BLOCKED";
export const SCREEN_NON_SUBSCRIBER = "NON_SUBSCRIBER";
export const SCREEN_PAYMENT_FAILED = "PAYMENT_FAILED";
export const SCREEN_REGISTRATION = "registrations";
export const SCREEN_SUBSCRIBER = "SUBSCRIBER";
export const SCREEN_TEST = "TEST";

export const PHONE = /^\(\d{2}\)\s?\d{4,5}-\d{4}$/;
/**
 * Máscara que aceita (99)9999-9999 ou (99)99999-9999
 * @param {string} rawValue — o valor bruto já digitado
 * @returns {Array<string|RegExp>}
 */
export const PHONE_NUMBER_MASK = (rawValue) => {
  // remove tudo que não for dígito
  const digits = rawValue.replace(/\D/g, "");
  // se tiver mais de 10 dígitos, é celular com 5 dígitos no prefixo
  const isCell = digits.length > 10;

  const mask = [
    "(",
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
    // insere um dígito extra só para celular
    isCell ? /\d/ : undefined,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ];
  // filter remove os `undefined`
  return mask.filter(Boolean);
};

// --- Internacionalização de telefone (DDI) ---
// Lista inicial — expanda quando quiser. nsnMin/nsnMax = tamanho do número nacional (sem DDI).
export const DDI_MAP = {
  1: { country: "US/CA", nsnMin: 10, nsnMax: 10 },
  7: { country: "RU/KZ", nsnMin: 10, nsnMax: 10 },
  20: { country: "EG", nsnMin: 8, nsnMax: 10 },
  27: { country: "ZA", nsnMin: 9, nsnMax: 9 },
  30: { country: "GR", nsnMin: 10, nsnMax: 10 },
  31: { country: "NL", nsnMin: 9, nsnMax: 9 },
  32: { country: "BE", nsnMin: 8, nsnMax: 9 },
  33: { country: "FR", nsnMin: 9, nsnMax: 9 },
  34: { country: "ES", nsnMin: 9, nsnMax: 9 },
  39: { country: "IT", nsnMin: 6, nsnMax: 10 },
  44: { country: "GB", nsnMin: 9, nsnMax: 10 },
  49: { country: "DE", nsnMin: 7, nsnMax: 11 },
  52: { country: "MX", nsnMin: 10, nsnMax: 10 },
  54: { country: "AR", nsnMin: 10, nsnMax: 10 },
  55: { country: "BR", nsnMin: 10, nsnMax: 11 },
  56: { country: "CL", nsnMin: 9, nsnMax: 9 },
  57: { country: "CO", nsnMin: 10, nsnMax: 10 },
  58: { country: "VE", nsnMin: 10, nsnMax: 10 },
  60: { country: "MY", nsnMin: 8, nsnMax: 10 },
  61: { country: "AU", nsnMin: 9, nsnMax: 9 },
  62: { country: "ID", nsnMin: 8, nsnMax: 11 },
  63: { country: "PH", nsnMin: 8, nsnMax: 10 },
  64: { country: "NZ", nsnMin: 8, nsnMax: 10 },
  65: { country: "SG", nsnMin: 8, nsnMax: 8 },
  66: { country: "TH", nsnMin: 8, nsnMax: 9 },
  81: { country: "JP", nsnMin: 9, nsnMax: 10 },
  82: { country: "KR", nsnMin: 8, nsnMax: 10 },
  84: { country: "VN", nsnMin: 8, nsnMax: 10 },
  86: { country: "CN", nsnMin: 10, nsnMax: 11 },
  90: { country: "TR", nsnMin: 10, nsnMax: 10 },
  91: { country: "IN", nsnMin: 10, nsnMax: 10 },
  92: { country: "PK", nsnMin: 9, nsnMax: 10 },
  351: { country: "PT", nsnMin: 9, nsnMax: 9 },
};

// return country from DDI, for example: DDI_MAP['55'].country === 'BR'
export const getCountryByDDI = (ddi = "") => {
  const rule = DDI_MAP[ddi];
  return rule ? rule.country : null;
};

// emoji de bandeira; sem dependências
export const flagEmoji = (iso2 = "") => {
  if (!iso2) return "🏳️";
  return iso2.toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
};

// Lista de DDIs para o dropdown (adicione os que precisar)
export const DDI_OPTIONS = [
  { ddi: "55", name: "Brasil", iso2: "BR" },
  { ddi: "1", name: "Estados Unidos/Canadá", iso2: "US" },
  { ddi: "44", name: "Reino Unido", iso2: "GB" },
  { ddi: "351", name: "Portugal", iso2: "PT" },
  { ddi: "33", name: "França", iso2: "FR" },
  { ddi: "34", name: "Espanha", iso2: "ES" },
  { ddi: "49", name: "Alemanha", iso2: "DE" },
  { ddi: "39", name: "Itália", iso2: "IT" },
  { ddi: "81", name: "Japão", iso2: "JP" },
  { ddi: "82", name: "Coreia do Sul", iso2: "KR" },
  { ddi: "86", name: "China", iso2: "CN" },
  { ddi: "91", name: "Índia", iso2: "IN" },
  { ddi: "52", name: "México", iso2: "MX" },
  { ddi: "54", name: "Argentina", iso2: "AR" },
  { ddi: "56", name: "Chile", iso2: "CL" },
  { ddi: "57", name: "Colômbia", iso2: "CO" },
  { ddi: "58", name: "Venezuela", iso2: "VE" },
  { ddi: "244", name: "Angola", iso2: "AO" },
  { ddi: "32", name: "Bélgica", iso2: "BE" },
  { ddi: "61", name: "Austrália", iso2: "AU" },
  { ddi: "62", name: "Indonésia", iso2: "ID" },
  { ddi: "63", name: "Filipinas", iso2: "PH" },
  { ddi: "64", name: "Nova Zelândia", iso2: "NZ" },
  { ddi: "65", name: "Singapura", iso2: "SG" },
  { ddi: "66", name: "Tailândia", iso2: "TH" },
  { ddi: "90", name: "Turquia", iso2: "TR" },
  { ddi: "27", name: "África do Sul", iso2: "ZA" },
];

// Mantém apenas um '+' no início e remove qualquer outro caractere
export const sanitizePhoneInput = (raw = "") => raw.replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "");
// Remove o '+' inicial e retorna só dígitos com DDI (E.164 sem '+')
export const toE164Digits = (raw = "") => sanitizePhoneInput(raw).replace(/^\+/, "");

// Extrai DDI por maior prefixo de 3..1 dígitos
export const extractDDI = (e164Digits = "") => {
  for (let len = 3; len >= 1; len--) {
    const code = e164Digits.slice(0, len);
    if (DDI_MAP[code]) return code;
  }
  return null;
};

// Validação: 8..15 dígitos totais, DDI conhecido, NSN dentro do intervalo
export const isValidInternationalPhone = (raw = "") => {
  const digits = toE164Digits(raw);
  if (digits.length < 8 || digits.length > 15) return false;
  const ddi = extractDDI(digits);
  if (!ddi) return false;
  const nsn = digits.slice(ddi.length);
  const rule = DDI_MAP[ddi];
  if (!rule) return false;
  return nsn.length >= rule.nsnMin && nsn.length <= rule.nsnMax;
};

// Exibição simples: "+DDI 1234 567 890" (sem regras específicas por país)
export const formatInternationalView = (raw = "") => {
  const clean = sanitizePhoneInput(raw);
  const digits = clean.replace(/^\+/, "");
  const ddi = extractDDI(digits);
  if (!ddi) return clean || "";
  const nsn = digits.slice(ddi.length);
  const groups = nsn.match(/\d{1,4}/g) || [];
  return `+${ddi} ${groups.join(" ")}`.trim();
};

// Ajusta o DDI de um número mantendo o NSN atual.
export const replacePhoneDDI = (raw = "", newDDI = "") => {
  const digits = toE164Digits(raw); // "5511999..."
  const currentDDI = extractDDI(digits) || "";
  const nsn = digits.slice(currentDDI.length);
  return `+${newDDI}${nsn}`;
};

export const ensureWithDefaultDDI = (raw = "", defaultDDI = "55") => {
  const clean = sanitizePhoneInput(raw); // mantém só dígitos e um '+' inicial
  const digits = clean.replace(/^\+/, "");

  if (!digits) return "";

  // Se o usuário já colou com '+', mantenha
  if (clean.startsWith("+")) {
    return clean;
  }

  // Detecta se o número parece ser brasileiro (10 ou 11 dígitos, sem DDI explícito)
  if (digits.length === 10 || digits.length === 11) {
    return `+${defaultDDI}${digits}`;
  }

  // Se já bate com algum DDI conhecido (1, 44, 351, etc.)
  const ddi = extractDDI(digits);
  if (ddi) {
    return `+${digits}`;
  }

  // fallback: prefixa o default DDI mesmo assim
  return `+${defaultDDI}${digits}`;
};
